export default Object.freeze({
  ACTIVE_POPOVER_PROJECT_ID: 'active_popover_project_id',
  BREADCRUMBS: 'breadcrumbs',
  CHOICES_TABLE: 'choices_table',
  CURRENT_CONTEXT: 'current_context',
  DATATABLE_SIZE: 'datatable_size',
  DRAWER_IS_FULL_PAGE: 'drawer_is_full_page',
  DROPDOWN_HIDE: 'dropdown_hide',
  EMITTER: 'emitter',
  FETCH_DECISION: 'fetch_decision',
  FETCH_DECISION_PROPOSALS: 'fetch_decision_proposals',
  FILTER_COMPOSABLE: 'filter_composable',
  FILTER_HIDE: 'filter_hide',
  FLIPPER: 'flipper',
  LANGUAGE_COLUMN_MODE: 'language_column_mode',
  PREVIEW_LANGUAGE: 'preview_language',
  TASK_EXPANSION_STATE: 'task_expansion_state',
  TICKET_ASSISTANT_OPEN: 'ticket_assistant_open',
});
